import { render } from "./NavBarComponent.vue?vue&type=template&id=97af44b4"
import script from "./NavBarComponent.vue?vue&type=script&lang=js"
export * from "./NavBarComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__